import { useStickyContactForm } from "./useStickyContactForm";
export function useIsStickyContactForm() {
    const isVariantB = useStickyContactForm("b");
    const isVariantC = useStickyContactForm("c");
    return isVariantB || isVariantC;
}
